<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-06-07 12:01:49
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Holiday\PublicHolidayGroup\editPublicHolidayGroup.vue
 -->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="
      iSEdited
        ? $t('label_essweb_holidayGroup_form_editTitle')
        : $t('label_essweb_holidayGroup_form_viewTitle')
    "
    delBtn
    :initData="PHGroupData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'holiday_group_name',
      'holiday_group_description',
      'holiday_group_code',
      'remarks',
    ]"
    pad="0"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_holidayGroup_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
      >
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation class="pa-8">
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  maxlength="100"
                  :bindData="PHGroupData.holiday_group_name"
                  @change="
                    (valueArr) => {
                      PHGroupData.holiday_group_name = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_holidayGroup_form_publicHolidayGroupLabel')
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                  maxlength="100"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="PHGroupData.holiday_group_code"
                />
              </v-col>
              <!-- <v-col  xs='12' sm="12" md='12' lg='12' cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  single-line
                  popClass="full-width"
                  :readonly="!iSEdited"
                  dense
                  :bindData="PHGroupData.holiday_group_description"
                  @change="
                    (valueArr) => {
                      PHGroupData.holiday_group_description = valueArr;
                    }
                  "
                  label="Description"
                />
              </v-col>-->
              <!-- <v-col  xs='12' sm="12" md='12' lg='12' cols="12">
                Remarks
                <v-textarea rows='3' no-resize
                  maxlength="150"
                  dense
                  :filled="iSEdited"
                  single-line
                  :readonly="!iSEdited"
                  v-model="PHGroupData.remarks"
                  name="input-7-4"
                  label="Remarks"
                ></v-textarea>
              </v-col>-->
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-card :elevation="0" class="pa-0">
            <v-card-text class="pa-0">
              <Tabler
                :headers="headers"
                :showNoContent="false"
                :items="desserts"
                :showSelect="showSelect"
              >
                <template v-slot:item.name="{ item }">
                  {{ $getCommonLangValue(item.holiday_name) }}
                </template>
                <template v-slot:item.date="{ item }">
                  {{ $getDateTime(item.holiday_utc_date, "YYYY/MM/DD") }}
                </template>
                <template v-slot:item.utc="{ item }">
                  {{ $getUtcByCode(item.holiday_time_zone) }}
                </template>
              </Tabler>
            </v-card-text>
            <v-card-actions class="pb-0 pl-0" v-if="iSEdited">
              <v-btn
                text
                color="primary"
                small
                class="text-capitalize mb-3 mx-3"
                @click="toNewMapping"
              >
                {{ $t("label_essweb_holidayGroup_form_editHolidayBtnLabel") }}
                <span class="material-icons-round">add</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->

    <!-- tools -->
    <template v-slot:tools-main>
      <mapToPublicHoliday
        :show="mapToDiag"
        :action="curAction"
        :PorpertyData="curPorperty"
        @newPorperty="onNewProperty"
        @editPorperty="onEditProperty"
        @closeDialog="mapToDiag = false"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import mapToPublicHoliday from "@/Page/EssAdmin/Holiday/PublicHolidayGroup/components/mapToPublicHoliday";
import { mapGetters } from "vuex";
export default {
  name: "editPublicHolidayGroup",
  components: { mapToPublicHoliday },
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      iSEdited: true,
      curTab: "tab-1",
      isChanged: false,
      taber: [
        "label_essweb_holidayGroup_form_step_generalLabel",
        "label_essweb_holidayGroup_form_step_holidayListLabel",
      ],
      mapToDiag: false,
      curAction: "new",
      showSelect: false,
      curPorperty: null,
      page: 1,
      PHGroupData: {
        holiday_group_name: "",
        holiday_group_code: "",
        holiday_group_description: "",
        remarks: "",
      },
      desserts: [],
      curUuids: [],
      headers: [
        {
          text: "label_essweb_holidayGroup_form_holidayNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayGroup_form_holidayDateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayGroup_form_holidayZoneLabel",
          value: "utc",
          align: "start",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    desserts(val) {
      const that = this;
      val.forEach(function (item) {
        that.curUuids.push(item.uuid);
      });
      this.curPorperty = val;
    },
  },
  mounted() {
    this.getHolidayGroupDetail();
    this.getPorpertyList();
  },
  methods: {
    getHolidayGroupDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_group",
        url: "/holiday-group/get-holiday-group-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["holiday_group_name_save"] = res.data.holiday_group_name;
        res.data.holiday_group_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.holiday_group_name
        );
        res.data["holiday_group_description_save"] =
          res.data.holiday_group_description;
        res.data.holiday_group_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.holiday_group_description
        );

        that.PHGroupData = res.data;
      });
    },
    onNewProperty: function (obj) {},
    onEditProperty: function (obj) {
      this.mapToDiag = false;
      const that = this;
      var newUuids = [];
      var newYears = [];
      obj.forEach(function (item) {
        newUuids.push(item.uuid);
        newYears.push(item.year);
      });
      // //交集
      // let intersection = this.desserts.filter((v) => obj.includes(v));
      // //差集
      // let difference = this.desserts
      //   .concat(obj)
      //   .filter((v) => !this.desserts.includes(v) || !obj.includes(v));
      // //并集
      // let curAll = this.desserts.concat(
      //   obj.filter(function (v) {
      //     return !(that.desserts.indexOf(v) > -1);
      //   })
      // );
      this.toEditHoliday(newUuids); //2021-08-23 BJ
      // this.toDeleteHoliday(this.curUuids, newUuids, newYears);
    },
    toNewMapping: function () {
      const that = this;
      this.curAction = "edit";
      this.curPorperty = [];
      this.$Sleep(300).then(() => {
        that.curPorperty = that.desserts;
      });
      this.mapToDiag = true;
    },
    getPorpertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday-mapping/get-holiday-mapping-list/",
        data: {
          holiday_group_uuid: this.$route.params.id,
        },
      }).then((res) => {
        // 排序
        res.data.sort((objectN, objectM) => {
          var valueN = objectN["holiday_utc_date"];
          var valueM = objectM["holiday_utc_date"];
          if (valueN < valueM) return 1;
          else if (valueN > valueM) return -1;
          else return 0;
        });
        that.desserts = res.data;
        // res.data.forEach(function(item) {
        //   that.desserts.push({
        //     uuid: item.day_uuid,
        //     holiday_name: item.holiday_name,
        //     holiday_utc_date: item.holiday_utc_date,
        //     holiday_time_zone: item.holiday_time_zone,
        //     year: item.year,
        //   });
        // });
      });
    },

    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_group",
        url: "/holiday-group/update-holiday-group-table/",
        data: {
          uuid: this.$route.params.id,
          holiday_group_name: this.$transCommonLangKey(
            this.PHGroupData.holiday_group_name,
            this.PHGroupData.holiday_group_name_save
          ),
          holiday_group_code: this.PHGroupData.holiday_group_code,
          holiday_group_description: this.$transCommonLangKey(
            this.PHGroupData.holiday_group_description,
            this.PHGroupData.holiday_group_description_save
          ),
          remarks: this.PHGroupData.remarks,
        },
      }).then((res) => {
        that.$toBack();
        that.$showMessage({
          text: that.$t(
            "message_essweb_holidayGroup_list_updatePublicHolidayGroupSuccessLabel"
          ),
          type: "success",
        });
      });
    },
    toEditHoliday: function (uuids) {
      const that = this;
      //2021-02-18
      // if (uuids.length == 0) {
      //   that.getPorpertyList();
      // } else {
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_group",
        url: "/holiday-mapping/update-holiday-mapping-table/",
        data: {
          holiday_group_uuid: this.$route.params.id,
          latest_ids: uuids.join(","),
        },
      }).then((res) => {
        that.getPorpertyList();
      });
      // }
    },
    toDeleteHoliday: function (uuids, newUuids, newYears) {
      const that = this;
      if (uuids.length == 0) {
        that.toAddHoliday(newUuids, newYears);
      } else {
        this.$Request({
          method: "POST",
          table: "ess_holi_map_holiday_group_day",
          url: "/holiday-mapping/delete-holiday-mapping-table/",
          data: {
            holiday_group_uuid: this.$route.params.id,
            uuids: uuids.join(","),
          },
        }).then((res) => {
          that.$showMessage({
            color: "success",
            text: that.$t("message_essweb_system_operation_sucess_deleteLabel"),
            type: "success",
          });
          that.toAddHoliday(newUuids, newYears);
        });
      }
    },
    toAddHoliday: function (uuids, years) {
      const that = this;
      if (uuids.length == 0) {
        that.getPorpertyList();
      } else {
        this.$Request({
          method: "POST",
          table: "ess_holi_map_holiday_group_day",
          url: "/holiday-mapping/add-holiday-mapping-table/",
          data: {
            holiday_group_uuid: this.$route.params.id,
            uuids: uuids.join(","),
            years: years.join(","),
          },
        }).then((res) => {
          that.getPorpertyList();
        });
      }
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_group",
        url: "/holiday-group/delete-holiday-group-table/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t(
            "message_essweb_holidayGroup_list_deletePublicHolidayGroupSuccessLabel"
          ),
          type: "success",
        });
        that.$toBack();
      });
    },
  },
};
</script>
